module.exports = __webpack_public_path__ + "dingbeauty-build/img/service@2.f45fe646.jpg";